// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"l8-z","button":"m8-z","disabled":"n8-z","creditCard":"o8-z","wrapper":"p8-z"};